var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map_container"},[_c('svg',{ref:"svgMap",staticClass:"base_map_embed",attrs:{"width":"100%","height":_vm.height}},[_c('g',{ref:"world_countries"}),_c('g',{ref:"world_lines"})])])}
var staticRenderFns = []

export { render, staticRenderFns }